
































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Event } from '../models/event';

@Component
export default class EventInfoOptionsComponent extends Vue {
  @Prop({ required: true })
  event!: Event;
}
